/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { ReactComponent as LogoGreenfy } from 'images/newLogo/Greenfy-logo-color.svg';
import logoBludocc from 'images/bludocc-logo.png';
import styled, { css } from 'styled-components';
import { Typography } from '@mui/material';

const mediaQuery = css`
  @media (max-width: 800px) {
    max-width: 80px;
  }
  @media (max-width: 600px) {
    display: none;
  }
`;

const commonStylesLogin = css`
  width: 236px;
  height: 56px;
  max-height: 120px;
  margin-top: 1rem;
`;

const StyledGreenfyLogo = styled(LogoGreenfy)`
  ${({ isLogin }) => isLogin && commonStylesLogin}
  ${({ isMenuHeader }) =>
    isMenuHeader &&
    css`
      max-width: 70px;
      width: 70%;
      display: flex;
      ${mediaQuery}
    `}
`;

const StyledBludoccLogo = styled.img`
  ${({ isLogin }) => isLogin && commonStylesLogin}
  ${({ isMenuHeader }) =>
    isMenuHeader &&
    css`
      max-width: 100px !important;
      ${mediaQuery}
    `}
`;

function PlatformLogo({
  size,
  srcLogoBludocc,
  isMenuHeader = false,
  isLogin = false,
  styleGreenfyLogo = {},
  styleBludoccLogo = {},
}) {
  const isCrevettic = process.env.REACT_APP_PLATAFORM === 'crevettic';

  return (
    <>
      {isCrevettic ? (
        <div
          style={{
            display: 'flex',
            gap: '7px',
            justifyContent: 'space-between',
            height: 'auto',
            alignItems: 'center',
          }}
        >
          <StyledBludoccLogo
            src={srcLogoBludocc || logoBludocc}
            alt="Logo Bludocc"
            isMenuHeader={isMenuHeader}
            isLogin={isLogin}
            style={styleBludoccLogo}
          />
          <p
            style={{
              color: '#000',
              fontSize: '14px',
              margin: 0,
            }}
          >
            powered by
          </p>

          <StyledGreenfyLogo
            aria-label="Logo Greenfy"
            size={size}
            isMenuHeader={isMenuHeader}
            isLogin={isLogin}
            style={styleGreenfyLogo}
          />
        </div>
      ) : (
        <StyledBludoccLogo
          src={srcLogoBludocc || logoBludocc}
          alt="Logo Bludocc"
          isMenuHeader={isMenuHeader}
          isLogin={isLogin}
          style={styleBludoccLogo}
        />
      )}
    </>
  );
}

export default PlatformLogo;
